import Client from "./Client";
import Company from "Class/Company";
import { AnyObject } from "types";

const resource = "/companies";

export default class CompanyService {
  public static async listAllCompanies(
    page: number,
    page_size: number
  ): Promise<AnyObject> {
    let url = `${resource}`;
    if (page !== 0 && page_size !== 0)
      url = `${resource}?page=${page}&page_size=${page_size}`;
    const { data } = await Client.get(url);
    return data;
  }

  public static async getCompany(companyId: number): Promise<Company> {
    const { data } = await Client.get(`${resource}/${companyId}`);
    const comp = new Company(data.data);
    return comp;
  }

  public static async getDetails(): Promise<Company> {
    const { data } = await Client.get(`${resource}/details`);
    const comp = new Company(data.data);
    return comp;
  }

  public static async getCompanyByName(name: string): Promise<AnyObject> {
    const { data } = await Client.get(`${resource}/search?name=${name}`);
    return data;
  }

  public static async createCompany(company: Company): Promise<AnyObject> {
    const { data } = await Client.post(`${resource}`, company.asJSON());
    return data;
  }

  public static async updateCompany(company: Company): Promise<AnyObject> {
    const { data } = await Client.put(
      `${resource}/${company.id}`,
      company.asJSON()
    );
    return data;
  }

  public static async blockOrUnlock(
    companyId: number,
    blocked: boolean
  ): Promise<string> {
    if (blocked) {
      await Client.put(`${resource}/${companyId}/unblock`);
      return "Empresa desbloqueada con exito";
    } else {
      await Client.put(`${resource}/${companyId}/block`);
      return "Empresa bloqueada con exito";
    }
  }

  public static async deleteCompany(companyId: number): Promise<string> {
    await Client.delete(`${resource}/${companyId}/remove`);
    return "Empresa eliminada exitosamente";
  }
}
